import { parserPropTypes, parserPropTypesDefaults } from '../Constants';

const conditionalCss = () =>
{
    const Wrapper = ({
        type = parserPropTypesDefaults.type,
        attribs = parserPropTypesDefaults.attribs
    }) =>
    {
        if ( type !== 'tag' ) return null;
        if (
            !attribs?.class ||
            !attribs.class.includes('wp-block-group')
        ) return null;
        const attribClasses = attribs.class.split(' ');
        if ( attribClasses.includes('hero-with-ctas') )
        {
            import( '../../../../../components/Templates/block-patterns/hero-with-ctas/hero-with-ctas.scss' );
        }
        if ( attribClasses.includes('cdm-accounts-container') )
        {
            import( '../../../../../components/Templates/block-patterns/cdm-accounts-container/cdm-accounts-container.scss' );
        }

        return null;
    }
    Wrapper.propTypes = parserPropTypes;
    return Wrapper;
}
export default conditionalCss;